import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { InterviewSection } from './components/InterviewSection';
import { IngredientsSection } from './components/IngredientsSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PricingSection } from './components/PricingSection';
export function App() {
  useEffect(() => {
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '782456421382407');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=782456421382407&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.head.appendChild(noscript);
    // Microsoft Clarity
    const clarityScript = document.createElement('script');
    clarityScript.innerHTML = `
      (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      })(window, document, "clarity", "script", "w9e23w065c");
    `;
    document.head.appendChild(clarityScript);
    // Taboola Pixel
    const taboolaScript = document.createElement('script');
    taboolaScript.innerHTML = `
      window._tfa = window._tfa || [];
      window._tfa.push({notify: 'event', name: 'page_view', id: 2020143});
      !function (t, f, a, x) {
        if (!document.getElementById(x)) {
          t.async = 1;t.src = a;t.id=x;f.parentNode.insertBefore(t, f);
        }
      }(document.createElement('script'),
      document.getElementsByTagName('script')[0],
      '//cdn.taboola.com/libtrc/unip/2020143/tfa.js',
      'tb_tfa_script');
    `;
    document.head.appendChild(taboolaScript);
    // Taboola CTA click tracking
    document.querySelectorAll('a[href*="clearguardnutrition.com"]').forEach(link => {
      link.addEventListener('click', () => {
        ;
        (window as any)._tfa = (window as any)._tfa || [];
        (window as any)._tfa.push({
          notify: 'event',
          name: 'ADV_CLICK_TO_SALES_PAGE',
          id: 2020143
        });
      });
    });
    // Taboola Click ID passthrough
    const urlParams = new URLSearchParams(window.location.search);
    const tblci = urlParams.get('tblci');
    if (tblci) {
      document.querySelectorAll('a[href*="clearguardnutrition.com"]').forEach(link => {
        const url = new URL((link as HTMLAnchorElement).href);
        url.searchParams.set('tblci', tblci);
        (link as HTMLAnchorElement).href = url.toString();
      });
    }
    // Google Analytics (GA4)
    ;
    (window as any).dataLayer = (window as any).dataLayer || [];
    (window as any).gtag = function () {
      ;
      (window as any).dataLayer.push(arguments);
    };
    (window as any).gtag('js', new Date());
    (window as any).gtag('config', 'G-TEW0MBTC4Q');
    if (!document.getElementById('ga_gtag_script')) {
      const gtagScript = document.createElement('script');
      gtagScript.async = true;
      gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-TEW0MBTC4Q';
      gtagScript.id = 'ga_gtag_script';
      document.head.appendChild(gtagScript);
    }
  }, []);
  return <main className="min-h-screen w-full flex flex-col items-center" data-id="element-0">
      <header className="w-full bg-white border-b border-stone-200 px-4 sm:px-6 lg:px-8 py-4" data-id="element-1">
        <div className="max-w-[760px] mx-auto flex items-center justify-between" data-id="element-2">
          <span className="text-xl sm:text-2xl font-bold font-serif" data-id="element-3">
            <span className="text-stone-800" data-id="element-4">Daily</span>
            <span className="text-[#2D6A4F]" data-id="element-5">Oral</span>
            <span className="text-stone-800" data-id="element-6">Report</span>
          </span>
          <span className="text-xs sm:text-sm tracking-[0.2em] uppercase text-stone-400 font-medium" data-id="element-7">
            Sponsored Advertorial
          </span>
        </div>
      </header>
      <div className="w-full flex flex-col items-center py-8 sm:py-12 px-4 sm:px-6 lg:px-8" data-id="element-8">
        <article className="w-full max-w-[760px] bg-white p-6 sm:p-10 md:p-14 shadow-sm border border-stone-200 rounded-sm" data-id="element-9">
          <HeroSection data-id="element-10" />
          <hr className="my-10 border-stone-200" data-id="element-11" />
          <InterviewSection data-id="element-12" />
          <IngredientsSection data-id="element-13" />
          <TestimonialsSection data-id="element-14" />
          <PricingSection data-id="element-15" />
        </article>
      </div>
    </main>;
}